import { render, staticRenderFns } from "./ReportsOrganizationalViolence.vue?vue&type=template&id=1ac729ff&scoped=true&"
import script from "./ReportsOrganizationalViolence.vue?vue&type=script&lang=js&"
export * from "./ReportsOrganizationalViolence.vue?vue&type=script&lang=js&"
import style0 from "./ReportsOrganizationalViolence.vue?vue&type=style&index=0&id=1ac729ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac729ff",
  null
  
)

export default component.exports